import { type ReactNode } from 'react';
import styles from './AppShell.module.css';
import { BottomTabs } from './BottomTabs';

interface AppShellProps {
  children: ReactNode;
  hideTabs?: boolean;
  dark?: boolean;
}

export function AppShell({ children, hideTabs, dark = true }: AppShellProps): JSX.Element {
  return (
    <div className={`${styles.shell} ${dark ? styles.dark : styles.light}`}>
      <main className={styles.main}>{children}</main>
      {!hideTabs && <BottomTabs />}
    </div>
  );
}
